import React from 'react'

const Dispatched = () => {
  return (
    <div className='dispatched'>Dispatched</div>
  )
}

export default Dispatched